<template>
  <v-app id="app">
    <v-main>
      <router-view />
      <BiddingWarning v-if="isBidding"/>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions } from "vuex";
import BiddingWarning from "./components/_Atoms/BiddingWarning";

export default {
  name: "App",
  components: { BiddingWarning },

  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    isBidding(){
      return sessionStorage.getItem("is_bidding") === 'true';
    }
  },

  watch: {
    isAuthenticated() {
      this.getPermissions();
    }
  },

  mounted() {
    this.getPermissions();
    let previousLanguageID = localStorage.getItem("lang");
    if (!['de', 'fr', 'es', 'pt', 'en_uk', 'en_us', 'es_la'].includes(previousLanguageID)) {
      this.setLanguageMessages("en_uk")
    }
  },

  methods: {
    ...mapActions([
      "fetchUserPermissionsAndRoles",
      "setCurrentUserPermissions",
      "fetchModulesStates",
      "LOGOUT"
    ]),

    /**
     * Sets messages for the selected language
     */
     setLanguageMessages(language) {
      this.$i18n.locale = language;
      this.$i18n.setLocaleMessage(
        language,
        require(`@/langs/${language}.json`)
      );
      localStorage.setItem("lang", language);
    },


    async getPermissions() {
      if (this.isAuthenticated) {
        try {
          await this.getModulesStates();
          await this.fetchUserPermissionsAndRoles();
        } catch (error) {
          console.error(error);
          this.logout();
        }
      }
    },

    async getModulesStates() {
      if (this.isAuthenticated) {
        try {
          await this.fetchModulesStates();
        } catch (error) {
          console.error(error);
          this.logout();
        }
      }
    },

    async logout() {
      try {
        await this.LOGOUT();
        if (this.$route && this.$route.path !== "/login") {
          await this.$router.push({ name: "login" });
        }
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/App.vue